import { EphemeralCert, MTLS, ResponseData } from '@clipsalsolar/capacitor-mtls';

import { IS_RUNNING_TESTS } from '../../common/constants';

export async function MTLSRequest<T>(opts: {
  url: string;
  method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  headers?: Record<string, string>;
  body?: unknown;
  timeoutMs?: number;
  cert?: EphemeralCert;
}) {
  const { url, method = 'GET', headers = {}, body, timeoutMs, cert } = opts;

  let response: ResponseData;
  if (IS_RUNNING_TESTS) {
    response = (await fakeFetch(url, method, headers, body)) as unknown as ResponseData;
  } else {
    response = await MTLS.request({
      url,
      method,
      headers: {
        Accept: 'application/json',
        ...headers,
      },
      body: body ? JSON.stringify(body) : undefined,
      timeoutMs,
      cert,
    });
  }

  if (response.status < 200 || response.status >= 300) {
    const msg = response.body?.slice?.(0, 500) ?? String(response.body);
    throw new Error(`HTTP ${response.status} ${url} \u2013 ${msg}`);
  }

  let parsedData: T;
  try {
    parsedData = response.body ? (JSON.parse(response.body) as T) : ({} as T);
  } catch {
    parsedData = response.body as T;
  }

  return {
    data: parsedData,
    status: response.status,
    headers: response.headers,
    details: response.details,
  };
}

/*
 * Fake fetch function for use in tests.
 */
async function fakeFetch(
  url: string,
  method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE',
  headers?: Record<string, string>,
  body?: unknown
): Promise<{ status: number; body: string }> {
  const res = await fetch(url, {
    method,
    headers: { Accept: 'application/json', ...headers },
    body: body ? JSON.stringify(body) : undefined,
  });

  const text = await res.text();
  return { status: res.status, body: text };
}
